
<div class="ui stackable grid">

  <div class="eight wide column">
    <h3>立候補申請</h3>
    <candidate-detail v-if="candidate && !isEditing" :candidate="candidate"></candidate-detail>
    <div v-if="candidate && !isEditing" style="margin-top: 10px; display: flex; justify-content: flex-end;">
      <button class="ui button" type="button" @click.prevent="openEdit">申請情報を修正する</button>
    </div>
    <form v-if="!candidate || isEditing" class="ui form" :class="{'warning': postForm.hasErrors()}">
      <div class="fields">
        <div class="required field">
          <label>担当者名(必須)</label>
          <input type="text" v-model="postForm.model.operator_name">
          <validation-message :form="postForm" :field="'operator_name'"></validation-message>
        </div>
      </div>
      <div class="required field">
        <label>お客様向け立候補コメント(必須)</label>
        <textarea v-model="postForm.model.message"></textarea>
        <validation-message :form="postForm" :field="'message'"></validation-message>
      </div>

      <div ref="candidateAccordion" class="ui fluid accordion" style="margin-bottom: 20px;">
        <div class="title active">
          <i class="dropdown icon"></i> お客様に提案するコース情報を入力する
        </div>
        <div class="content active">
          <div class="ui positive message">
          普段とは違う特別なコース内容でご提案するとお客様に選ばれやすくなります
          <span v-if="canChoosePlan"><br>登録済みのコース情報をコピーしていただくとスムーズに入力できます。</span>
          </div>
          <div v-if="canChoosePlan" style="margin-bottom: 10px;">
            <div class="ui checkbox radio" v-if="shop && shop.courses.length > 0">
              <input type="radio" id="courses" v-model="selectedPlanType" name="plan_type" :value="consts.PLAN_TYPE_TO_VALUE.course">
              <label for="courses" style="cursor: pointer;">宴会</label>
            </div>
            <div class="ui checkbox radio" v-if="shop && shop.meetings.length > 0">
              <input type="radio" id="meetings" v-model="selectedPlanType" name="plan_type" :value="consts.PLAN_TYPE_TO_VALUE.meeting">
              <label for="meetings" style="cursor: pointer;">会議室</label>
            </div>
            <div class="ui checkbox radio" v-if="shop && shop.lodge_meetings.length > 0">
              <input type="radio" id="lodge-meetings" v-model="selectedPlanType" name="plan_type" :value="consts.PLAN_TYPE_TO_VALUE.lodgeMeeting">
              <label for="lodge-meetings" style="cursor: pointer;">宿泊会議</label>
            </div>
          </div>
          <div v-if="canChoosePlan" class="fields">
            <div class="ten wide field">
              <dropdown v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.course" v-model="selectedCourseId" :placeholder="'--- コピーするコース情報を選択 ---'">
                <option v-for="course in shop.courses" :value="course.id" :key="consts.PLAN_TYPE_TO_VALUE.course + course.id">{{ course.name }}</option>
              </dropdown>
              <dropdown v-else-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.meeting" v-model="selectedMeetingId" :placeholder="'--- コピーするコース情報を選択 ---'">
                <option v-for="meeting in shop.meetings" :value="meeting.id" :key="consts.PLAN_TYPE_TO_VALUE.meeting + meeting.id">{{ meeting.name }}</option>
              </dropdown>
              <dropdown v-else-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.lodgeMeeting" v-model="selectedLodgeMeetingId" :placeholder="'--- コピーするコース情報を選択 ---'">
                <option v-for="lodgeMeeting in shop.lodge_meetings" :value="lodgeMeeting.id" :key="consts.PLAN_TYPE_TO_VALUE.lodgeMeeting + lodgeMeeting.id">{{ lodgeMeeting.name }}</option>
              </dropdown>
            </div>
            <button @click="copyCourse" class="ui tiny teal button" type="button"><i class="arrow down large icon"></i>コース内容をコピーする</button>
          </div>
          <div class="ui grid fields">
            <div class="eight wide column field">
              <label>価格(税込)</label>
              <div class="ui right labeled input">
                <input type="number" v-model="postForm.model.price" placeholder="4000">
                <label class="ui label">円</label>
              </div>
              <validation-message :form="postForm" :field="'price'"></validation-message>
            </div>
            <div class="eight wide column field">
              <label>品数</label>
              <div class="ui right labeled input">
                <input type="number" v-model="postForm.model.dish_count" placeholder="8">
                <label class="ui label">品</label>
              </div>
              <validation-message :form="postForm" :field="'dish_count'"></validation-message>
            </div>
          </div>
          <div class="field">
            <label>コース詳細</label>
            <div v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.course">
              <textarea v-model="postForm.model.course_detail" rows="12"></textarea>
              <validation-message :form="postForm" :field="'course_detail'"></validation-message>
            </div>
            <div v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.meeting">
              <textarea v-model="postForm.model.meeting_detail" rows="12"></textarea>
              <validation-message :form="postForm" :field="'meeting_detail'"></validation-message>
            </div>
            <div v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.lodgeMeeting">
              <textarea v-model="postForm.model.lodge_meeting_detail" rows="12"></textarea>
              <validation-message :form="postForm" :field="'lodge_meeting_detail'"></validation-message>
            </div>
          </div>
        </div>
        <!--div class="title">
          <i class="dropdown icon"></i> コンシェルジュへのメッセージを入力する
        </div>
        <div class="content">
          <textarea v-model="postForm.model.message_for_concierge" rows="3"></textarea>
          <validation-message :form="postForm" :field="'message_for_concierge'"></validation-message>
        </div-->
      </div>

      <div class="ui stackable grid">
        <div class="six wide column">
          <button v-if="!candidate" class="ui primary large button " type="button" :class="{loading: postForm.waiting}" @click.prevent="post">立候補する</button>
          <button v-else class="ui primary large button " type="button" :class="{loading: postForm.waiting}" @click.prevent="update">立候補内容を更新する</button>
        </div>
        <div class="ten wide column">
          <button class="ui large button" type="button" @click.prevent="openPreview">入力した内容をプレビュー表示する</button>
        </div>
      </div>
      <div v-if="candidate" style="margin-top: 10px;">
        <button class="ui basic button" type="button" @click.prevent="cancelEdit">キャンセル</button>
      </div>


      <div id="candidatePreview" class="ui modal">
        <i class="close icon"></i>
        <div class="header">お客様画面のプレビュー</div>
        <div class="scrolling content">
          <div class="ui positive message">お客様に以下の内容が表示されます。</div>
          <candidate-detail :candidate="postForm.model" :plan-type="selectedPlanType"></candidate-detail>
        </div>
        <div class="actions">
          <button class="ui cancel button">閉じる</button>
        </div>
      </div>
    </form>
  </div>

  <div class="eight wide column">
    <h3>宴会情報</h3>
    <table class="ui definition keyValueTable table">
      <tr>
        <td>お問合せ番号</td>
        <td>{{ marunage.code }}</td>
      </tr>
      <tr>
        <td>お問合せ日時</td>
        <td>{{ marunage.event_date | formatDate }} {{ marunage.event_time }}</td>
      </tr>
      <tr>
        <td>希望エリア</td>
        <td>{{ marunage.area_label }}</td>
      </tr>
      <tr>
        <td>エリア詳細</td>
        <td>{{ marunage.area_detail_label }}</td>
      </tr>
      <tr>
        <td>利用趣旨</td>
        <td>{{ marunage.purpose }}</td>
      </tr>
      <tr>
        <td>希望日時</td>
        <td>{{ marunage.event_date | formatDate }} {{ marunage.event_time }}</td>
      </tr>
      <tr>
        <td>人数</td>
        <td>{{ marunage.people_label }}</td>
      </tr>
      <tr>
        <td>一人当たりの予算</td>
        <td>{{ marunage.price_label }}</td>
      </tr>
      <tr>
        <td>希望条件など</td>
        <td class="linebreak">{{ marunage.note }}</td>
      </tr>
      <tr>
        <td>コンシェルジュからの<br>申し送り事項</td>
        <td class="linebreak">{{ marunage.message_for_shop }}</td>
      </tr>
    </table>
    <div v-if="marunage.related_chat_url" style="margin-top: 10px; display: flex; justify-content: flex-end;">
      <a :href="marunage.related_chat_url">
        <button class="ui positive button" type="button">チャットを確認する</button>
      </a>
    </div>
    <div v-if="candidate" style="margin-top: 10px; display: flex; justify-content: flex-end;">
      <button class="ui negative button" type="button" :class="{loading: withdrawForm.waiting}" @click.prevent="withdraw">立候補を取り下げる</button>
    </div>
  </div>

</div>
